import React, { useState, useEffect } from 'react';
import api from '../api';
import { FaLeaf, FaTree, FaCar, FaBolt, FaGlobeAmericas } from 'react-icons/fa';

const EnvironmentalImpact = () => {
  const [impacts, setImpacts] = useState([]);

  // --- ICON MAP ---
  const iconMap = {
    "FaBolt": <FaBolt />,
    "FaLeaf": <FaLeaf />,
    "FaTree": <FaTree />,
    "FaCar": <FaCar />,
    "FaGlobe": <FaGlobeAmericas /> // Fallback
  };

  // We reuse the API created in the Benefits step
  

  useEffect(() => {
    const fetchImpacts = async () => {
      try {
        const res = await api.get('/Benefits/impact');
        if (res.data && res.data.length > 0) {
          setImpacts(res.data);
        } else {
          // Fallback Data if DB is empty
          setImpacts([
            { iconEmoji: 'FaBolt', value: '37,500', unit: 'kWh', label: 'Clean Energy', description: 'Over 25 years', colorHex: '#FFD700' },
            { iconEmoji: 'FaLeaf', value: '35', unit: 'Tons', label: 'CO₂ Reduced', description: 'Combating climate change', colorHex: '#4CAF50' }
          ]);
        }
      } catch (err) {
        console.error("Error fetching impact stats:", err);
      }
    };

    fetchImpacts();
  }, []);

  return (
    <section className="environmental-impact py-5" style={{ background: 'linear-gradient(135deg, #E8F8F3 0%, #F0FFF4 100%)' }}>
      <div className="container">
        
        {/* Section Header */}
        <div className="text-center mb-5">
          <span className="badge bg-success mb-3 px-3 py-2">
            <FaLeaf className="me-2" />
            Environmental Impact
          </span>
          <h2 className="display-5 fw-bold text-dark mb-3">
            Your Solar Impact on Planet Earth
          </h2>
          <p className="lead text-muted mb-2">
            Every 1 kW solar system you install makes a difference
          </p>
          <p className="text-muted small">
            Here's the environmental benefit your solar system provides over 25 years
          </p>
        </div>

        {/* Impact Cards (Dynamic) */}
        <div className="row g-4 mb-5">
          {impacts.map((impact, index) => (
            <div className="col-lg-3 col-md-6" key={index}>
              <div 
                className="card border-0 shadow-sm h-100 text-center p-4"
                style={{ transition: 'all 0.3s ease', cursor: 'pointer' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
                }}
              >
                {/* Icon */}
                <div 
                  className="impact-icon mx-auto mb-3"
                  style={{
                    width: '80px', height: '80px',
                    background: impact.colorHex, // Use DB Color
                    borderRadius: '50%',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '2.5rem', color: '#ffffff',
                    boxShadow: `0 8px 25px ${impact.colorHex}40`
                  }}
                >
                  {/* Map DB String to Icon */}
                  {iconMap[impact.iconEmoji] || <FaLeaf />}
                </div>

                {/* Value */}
                <h2 className="fw-bold mb-1" style={{ color: impact.colorHex, fontSize: '2.5rem' }}>
                  {impact.value}
                </h2>
                <p className="text-muted small mb-3">{impact.unit}</p>

                {/* Label */}
                <h5 className="fw-bold mb-2" style={{ color: '#1B3F6E', fontSize: '1.1rem' }}>
                  {impact.label}
                </h5>

                {/* Description */}
                <p className="text-muted small mb-0">
                  {impact.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Box (Static) */}
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div 
              className="card border-0 shadow-lg p-4 text-center"
              style={{ background: 'linear-gradient(135deg, #2E7D32 0%, #4CAF50 100%)' }}
            >
              <div className="card-body">
                <h4 className="text-white fw-bold mb-3">
                  <FaLeaf className="me-2" />
                  Make a Positive Environmental Impact Today
                </h4>
                <p className="text-white mb-4 opacity-90">
                  By choosing solar, you're not just saving money - you're actively contributing 
                  to a cleaner, greener future for Bihar & Jharkhand
                </p>
                <a 
                  href="#calculator" 
                  className="btn btn-light btn-lg rounded-pill px-5 fw-bold"
                  style={{ color: '#2E7D32' }}
                >
                  <i className="bi bi-calculator me-2"></i>
                  Calculate Your Environmental Impact
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default EnvironmentalImpact;